(function ($) {

    let requestData = {};

    /**
     * ShortList constructor
     *
     * @param options
     * @constructor
     */
    function ShortList(options) {
        console.log('ShortList initialization');

        if (!options) {
            throw new Error('No options passed to ShortList constructor');
        } else if (typeof options.isShortlistTable === 'undefined') {
            throw new Error('No option isShortlistTable passed to ShortList constructor');
        }

        this.options = $.extend({}, ShortList.defaults, options);
        this.setup();
    }

    ShortList.prototype.setup = function () {
        let self = this;
        $('body').on('click', '.add-to-shortlist,.remove-from-shortlist', function (event) {
            self.checkShortListItem($(event.target));
        });
    }

    /**
     * Check add/remove shortlist button
     *
     * @param obj
     */
    ShortList.prototype.checkShortListItem = function (obj) {
        event.preventDefault();

        requestData.businessID = obj.data('business-id');

        if (obj.hasClass('add-to-shortlist')) {
            requestData.action = 'add';
        } else {
            requestData.action = 'remove';
        }

        this.sendRequest(this);

    }

    /**
     * Send request
     */
    ShortList.prototype.sendRequest = function (self) {
        console.log(requestData);
        jQuery.ajax({
            type: 'POST',
            url: self.options.apiRoute,
            data: requestData,
            dataType: "json",
            beforeSend: function (xhr) {
                xhr.setRequestHeader('X-WP-Nonce', self.options.nonce);
            },
            success: function (response) {
                self.parseResponse(response, self);
            },
            error: function (data) {
                console.log(data);
            }
        });
    }

    /**
     * Parse request
     *
     * @param response
     */
    ShortList.prototype.parseResponse = function (response) {
        let self = this;
        console.log(response);
        if (response.status !== 'success') {
            console.log('Response error');
            return;
        }

        let button = $('.add-to-shortlist').add('.remove-from-shortlist').filter('[data-business-id="' + response.businessID + '"]');
        switch (response.action) {
            case 'add':
                button.toggleClass('add-to-shortlist').addClass('remove-from-shortlist');
                button.empty().append('Remove from shortlist');
                break;
            case 'remove':
                if (self.options.isShortlistTable) {
                    button.closest('.opportunities-card').remove();
                } else {
                    button.addClass('add-to-shortlist').toggleClass('remove-from-shortlist');
                    button.empty().append('Add to shortlist');
                }
                break;
        }
        self.checkContent();
    }

    /**
     * Show empty message if content is empty
     */
    ShortList.prototype.checkContent = function () {
        let content = $('.opportunities-card');
        if (content.length) {
            $('#empty-message').hide();
        } else {
            $('#empty-message').show();
        }
    }

    ShortList.defaults = {};
    window.ShortList = ShortList;

})(jQuery)